<template>
  <v-col>
    <v-tabs v-model="tab">
      <v-tab>Assign pois list</v-tab>
      <v-tab>Ambassadors  List</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <data-source-table
          itemController="ambassador-rel"
          itemIdentifyField="poi.name"
          :headers="headers"
          :options.sync="options"
          :selected-items.sync="selectedAd"
          ref="dataSourceRef"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <confirm-dialog
                :is-open.sync="dialogs.poi.isOpened"
                width="400"
                @confirm="addPoi"
                confirm-button-text="save"
              >
                <template v-slot:activator>
                  <v-btn
                    class="mx-2" color="green"
                    dark fab small
                    @click="openDialog('poi')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-plus
                        </v-icon>
                      </template>
                      Assign poi to Ambassador
                    </v-tooltip>
                  </v-btn>
                </template>
                <template v-slot:title>
                  Add poi to Ambassador
                </template>
                <template v-slot:body>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-autocomplete
                          v-model="dialogs.poi.data.ambassador_id"
                          :items="ambList"
                          :filter="nonDiacriticsSensitiveFilter"
                          item-text="login"
                          item-value="id"
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <DataList
                          :item-model.sync="dialogs.poi.data.poi"
                          :type-object="$constants.DATA_LISTS.POI_SELECT_LIST"
                          label="poi"
                          :item-text-function="item => `${item.id}: ${item.name}`"
                          clearable
                          multiple
                          dense
                          chips
                          small-chips
                          deletable-chips
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
              </confirm-dialog>

              <confirm-dialog
                :is-open.sync="dialogs.status.isOpened"
                @confirm="changeStatus"
                confirm-button-text="save"
              >
                <template v-slot:activator>
                  <v-btn
                    class="mx-2" color="red darken-3"
                    dark fab small
                    @click="openDialog('status')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-list-status
                        </v-icon>
                      </template>
                      Change status
                    </v-tooltip>
                  </v-btn>
                </template>
                <template v-slot:title>
                  Change status
                </template>
                <template v-slot:body>
                  <v-autocomplete
                    v-model="dialogs.status.data.status"
                    :items="statuses"
                    :filter="nonDiacriticsSensitiveFilter"
                    item-text="name"
                    item-value="id"
                    dense
                  />
                </template>
              </confirm-dialog>

              <confirm-dialog
                :is-open.sync="dialogs.paymentStatus.isOpened"
                @confirm="changePaymentStatus"
                confirm-button-text="save"
              >
                <template v-slot:activator>
                  <v-btn
                    class="mx-2" color="primary"
                    dark fab small
                    @click="openDialog('paymentStatus')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-cash-sync
                        </v-icon>
                      </template>
                      Change payment status
                    </v-tooltip>
                  </v-btn>
                </template>
                <template v-slot:title>
                  Change payment status
                </template>
                <template v-slot:body>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-autocomplete
                          v-model="dialogs.paymentStatus.data.paymentStatus"
                          :items="paymentsStatuses"
                          :filter="nonDiacriticsSensitiveFilter"
                          item-text="name"
                          item-value="id"
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-switch
                          v-model="dialogs.paymentStatus.data.updateMilestone"
                          label="Update milestone"
                        ></v-switch>
                        <v-text-field
                          v-if="dialogs.paymentStatus.data.updateMilestone"
                          v-model="dialogs.paymentStatus.data.paymentMilestone"
                          type="number"
                          label="milestone"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
              </confirm-dialog>

              <v-btn
                class="mx-2" color="red darken-3"
                dark fab small
                @click="bulkDeletePoi"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" dark>
                      mdi-delete
                    </v-icon>
                  </template>
                  Bulk delete poi
                </v-tooltip>
              </v-btn>

              <v-spacer/>

              <v-btn
                  class="mx-2" color="blue darken-1"
                  outlined small
                  @click="$refs.dataSourceRef ? $refs.dataSourceRef.openDialogSelectColumns() : false"
              >
                Select columns
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:filter_poi.geotags>
            <GeotagList
              :geotag-model.sync="options.filters.geotags"
              label="geotags"
              multiple
              dense
            />
          </template>

          <template v-slot:item.poi.geotags="{ item }">
            {{ item.poi ? item.poi.geotags.map((geotag) => geotag.name).join(', ') : '' }}
          </template>

          <template v-slot:item.status="{ item }">
            <amb-status-icon :status="item.status" :statuses="statuses"></amb-status-icon>
            <v-btn icon :to="`ambassadors/poi/${item.id}`">
              <v-icon color="orange">
                mdi-pen
              </v-icon>
            </v-btn>
          </template>

          <template v-slot:item.payment_status="{ item }">
            <v-tooltip bottom :disabled="!item.payment_date">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                {{ paymentsStatuses.find(payment => payment.id === item.payment_status).name }}
                </span>
              </template>
              <span>{{ item.payment_date }}</span>
            </v-tooltip>
          </template>
        </data-source-table>
      </v-tab-item>
      <v-tab-item>
        <data-source-table
          itemController="ambassador"
          itemIdentifyField="login"
          :headers="ambHeaders"
          :options.sync="optionsAmb"
          :selected-items.sync="selectedAmbAd"
          ref="dataSourceAmbRef"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <confirm-dialog
                :is-open.sync="dialogs.addAmb.isOpened"
                @confirm="saveNewAmb"
                confirm-button-text="save"
              >
                <template v-slot:activator>
                  <v-btn
                    class="mx-2" color="primary"
                    dark fab small
                    @click="openDialog('addAmb')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <slot>
                          <v-icon v-bind="attrs" v-on="on" dark>
                            mdi-plus
                          </v-icon>
                        </slot>
                      </template>
                      create new Ambassador
                    </v-tooltip>
                  </v-btn>
                </template>
                <template v-slot:title>
                  <span class="headline">Ambassador</span>
                </template>
                <template v-slot:body>
                  <v-text-field
                    v-model="dialogs.addAmb.data.login"
                    label="Login"
                    :rules="[rules.required]"
                  />
                </template>
              </confirm-dialog>

              <confirm-dialog
                :is-open.sync="dialogs.changeAgreement.isOpened"
                @confirm="changeAgreementStatus"
                confirm-button-text="save"
              >
                <template v-slot:activator>
                  <v-btn
                    class="mx-2" color="green"
                    dark fab small
                    @click="openDialog('changeAgreement')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <slot>
                          <v-icon v-bind="attrs" v-on="on" dark>
                            mdi-text-box-edit-outline
                          </v-icon>
                        </slot>
                      </template>
                      Change agreement status
                    </v-tooltip>
                  </v-btn>
                </template>
                <template v-slot:title>
                  <span class="headline">Agreement status</span>
                </template>
                <template v-slot:body>
                  <v-autocomplete
                    v-model="dialogs.changeAgreement.data.status"
                    :items="agreementStatuses"
                    :filter="nonDiacriticsSensitiveFilter"
                    item-text="name"
                    item-value="id"
                    dense
                  />
                </template>
              </confirm-dialog>

              <v-spacer/>

              <v-btn
                  class="mx-2" color="blue darken-1"
                  outlined small
                  @click="$refs.dataSourceAmbRef ? $refs.dataSourceAmbRef.openDialogSelectColumns() : false"
              >
                Select columns
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:item.avatar="{ item }">
            <div class="amb-img" @click="openImageDialog(item)">
              <img v-if="item.public_link" :src="item.public_link" alt="" />
              <div v-else class="amb-placeholder">{{ avatarEmptyText(item) }}</div>
            </div>
          </template>

          <template v-slot:item.approved="{ item }">
            <v-btn v-if="!item.approved" fab x-small color="red" @click="approveAvatar(item)">
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn v-else fab x-small color="green">
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.agreement_status="{ item }">
            {{ agreementStatuses.find(status => status.id === item.agreement_status).name }}
          </template>
        </data-source-table>
      </v-tab-item>
    </v-tabs-items>

    <div>Dropbox using {{ dropbox.used }} of {{ dropbox.allocated }} storage</div>

    <v-dialog v-model="imageDialog.show" width="initial">
      <v-card>
        <v-img
          v-if="imageDialog.ambassador.public_link"
          :src="imageDialog.ambassador.public_link"
          max-height="600"
          max-width="600"
          min-height="300"
          min-width="300"
          contain
        />
        <div v-else class="empty-avatar-text">Ambassador has no avatar</div>
        <v-form
          v-if="imageDialog.showAddForm"
          v-model="imageDialog.valid"
          class="pa-3"
        >
          <v-file-input
            v-model="imageDialog.newAvatarFile"
            :rules="rulesAvatar"
            accept="image/png, image/jpeg, image/bmp"
            prepend-icon="mdi-plus"
            label="Avatar"
            required
          ></v-file-input>
          <div class="amb-img" style="height: 100px; width: 100px;">
            <img :src="newAvatar" alt="" />
          </div>
          <v-btn
            color="blue darken-1"
            text
            @click="updateAvatar"
            :disabled="!imageDialog.valid"
          >
            Ok
          </v-btn>
        </v-form>
        <div class="image-dialog-buttons">
          <div class="my-2" v-if="!imageDialog.ambassador.public_link">
            <v-btn fab x-small color="primary" @click="imageDialog.showAddForm = true">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
          <div class="my-2" v-if="imageDialog.ambassador.public_link">
            <v-btn fab x-small color="red" @click="deleteAvatar(imageDialog.ambassador)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
          <div class="my-2" v-if="imageDialog.ambassador.public_link">
            <v-btn
              fab x-small color="primary"
              download
            >
              <v-icon>mdi-tray-arrow-down</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapActions } from 'vuex';
import DataList from '@/components/DataLists/DataList.vue';
import AmbStatusIcon from '../../components/AmbStatusIcon.vue';
import DataSourceTable from '../../components/DataSource/DataTable.vue';
import ConfirmDialog from '../../components/dialogs/ConfirmDialog.vue';
import manageDialogsMixin from '../../mixins/manageDialogsMixin';
import GeotagList from '../../components/DataLists/GeotagList.vue';

export default {
  name: 'AmbassadorsList',
  components: {
    DataList,
    GeotagList,
    ConfirmDialog,
    DataSourceTable,
    AmbStatusIcon,
  },
  data: () => ({
    itemClone: {},
    tab: null,
    ambList: [],
    ambSearch: '',
    selectedAmbAd: [],
    optionsAmb: { filters: { } },
    statuses: [],
    paymentsStatuses: [],
    options: { filters: { } },
    selectedAd: [],
    dropbox: {},
    imageDialog: {
      ambassador: {},
      show: false,
      newAvatarFile: null,
      valid: false,
      showAddForm: false,
    },
    geotags: [],
    isLoadingGeotags: false,
    rules: {
      required: (v) => (!!v) || 'Field is required',
    },
    rulesAvatar: [
      (value) => !!value || 'Avatar is required',
      (value) => !value || value.size < 10000000 || 'Avatar size should be less than 10 MB!',
      (value) => !value || !!value.type.match('image.*') || 'Please choose an image file',
    ],
    agreementStatuses: [
      { id: 0, name: 'Not signed' },
      { id: 1, name: 'Signed' },
    ],
    dialogs: {
      poi: {
        isOpened: false,
        data: {
          ambassador_id: null,
          poi: null,
        },
        defaults: {
          ambassador_id: null,
          poi: null,
        },
      },
      status: {
        isOpened: false,
        data: {
          status: null,
        },
        defaults: {
          status: null,
        },
      },
      paymentStatus: {
        isOpened: false,
        data: {
          paymentStatus: null,
          updateMilestone: false,
          paymentMilestone: null,
        },
        defaults: {
          paymentStatus: null,
          updateMilestone: false,
          paymentMilestone: null,
        },
      },
      addAmb: {
        isOpened: false,
        data: {
          login: '',
        },
        defaults: {
          login: '',
        },
      },
      changeAgreement: {
        isOpened: false,
        data: {
          status: null,
        },
        defaults: {
          status: null,
        },
      },
    },
  }),

  mixins: [
    manageDialogsMixin,
  ],

  created() {
  },

  mounted() {
    this.$requestHelpers
      .get('api/admin/ambassador/poi/statuses')
      .then((response) => {
        this.statuses = response.data.result;
      });

    this.$requestHelpers
      .get('api/admin/ambassador/poi/payments-statuses')
      .then((response) => {
        this.paymentsStatuses = response.data.result;
      });

    this.$requestHelpers
      .get('api/admin/ambassador/media/dropbox')
      .then((response) => {
        this.dropbox = response.data.result;
      });

    this.$requestHelpers.get('api/admin/ambassador/get-valid-list')
      .then((response) => {
        this.ambList = response.data;
      });
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    addPoi() {
      this.$requestHelpers
        .post('api/admin/ambassador-rel/add-relations',
          {
            id: this.dialogs.poi.data.ambassador_id,
            poi: this.dialogs.poi.data.poi,
          })
        .then((response) => {
          if (response.data.success) {
            this.$refs.dataSourceRef.getApiData();
            if (response.data.result.length) {
              this.setSnack({
                text: response.data.result.join('<br/>'),
                color: 'blue',
              });
            }
          } else {
            this.setSnack({
              text: response.data.message,
              color: 'red',
            });
          }
        }).finally(() => {
          this.closeDialog('poi');
        });
    },

    changeStatus() {
      if (!this.selectedAd.length || this.dialogs.status.data.status === null) {
        this.closeDialog('status');
        return false;
      }

      return this.$refs.dataSourceRef.updateBulk(
        this.selectedAd.map((item) => item.id),
        { status: this.dialogs.status.data.status },
      ).finally(() => {
        this.closeDialog('status');
      });
    },

    changePaymentStatus() {
      if (!this.selectedAd.length || !this.dialogs.paymentStatus.data.paymentStatus === null) {
        this.closeDialog('paymentStatus');
        return false;
      }

      return this.$refs.dataSourceRef.updateBulk(
        this.selectedAd.map((item) => item.id),
        {
          payment_status: this.dialogs.paymentStatus.data.paymentStatus,
          update_milestone: this.dialogs.paymentStatus.data.updateMilestone,
          payment_milestone: this.dialogs.paymentStatus.data.paymentMilestone,
        },
      ).finally(() => {
        this.closeDialog('paymentStatus');
      });
    },

    bulkDeletePoi() {
      if (!this.selectedAd.length) {
        return;
      }

      this.$confirm(
        `Are you sure you want to delete ${this.selectedAd.length} poi?`,
      ).then((res) => {
        if (!res) return;

        this.$refs.dataSourceRef.removeBulk(this.selectedAd.map((item) => item.id));
      });
    },

    saveNewAmb() {
      this.$refs.dataSourceAmbRef.saveNew(this.dialogs.addAmb.data)
        .finally(() => {
          this.closeDialog('addAmb');
        });
    },

    changeAgreementStatus() {
      if (!this.selectedAmbAd.length || this.dialogs.changeAgreement.data.status === null) {
        this.closeDialog('changeAgreement');
        return;
      }

      this.$refs.dataSourceAmbRef.updateBulk(
        this.selectedAmbAd.map((item) => item.id),
        { agreement_status: this.dialogs.changeAgreement.data.status },
      ).finally(() => {
        this.closeDialog('changeAgreement');
        this.$refs.dataSourceAmbRef.clearSelectedItems();
      });
    },

    openImageDialog(ambassador) {
      this.imageDialog.ambassador = ambassador;
      this.imageDialog.show = true;
      this.imageDialog.newAvatarFile = null;
      this.imageDialog.showAddForm = false;
    },

    updateAmb(field, value, item) {
      return this.$refs.dataSourceAmbRef.updateItemField(field, value, item);
    },

    approveAvatar(ambassador) {
      return this.updateAmb('approved', 1, ambassador);
    },

    deleteAvatar(ambassador) {
      this.$confirm(
        `Are you sure you want to delete ${ambassador.login} avatar?`,
      ).then((res) => {
        if (!res) return;

        this.updateAmb('delete_avatar', 1, ambassador);
      });
    },

    updateAvatar() {
      if (this.imageDialog.newAvatarFile === null) {
        return;
      }

      const formData = new FormData();
      formData.append('id', this.imageDialog.ambassador.id);
      formData.append('avatar_image', this.imageDialog.newAvatarFile);
      this.$requestHelpers.post('api/admin/ambassador/update-avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        this.$refs.dataSourceAmbRef.updateData(response.data.result);
        this.imageDialog.showAddForm = false;
        this.imageDialog.newAvatarFile = null;
      });
    },

    avatarEmptyText(amb) {
      let text = amb.nickname;
      if (!text) text = amb.first_name;
      if (!text) text = amb.login;
      if (text) {
        return Array.from(text)[0].toUpperCase();
      }
      return '';
    },
  },

  computed: {
    headers() {
      return [
        {
          text: 'status',
          value: 'status',
          filter: { type: 'select', items: this.statuses },
        },
        {
          text: 'poi id',
          value: 'poi.id',
        },
        {
          text: 'poi name',
          value: 'poi.name',
        },
        {
          text: 'geotags',
          value: 'poi.geotags',
        },
        {
          text: 'ambassador',
          value: 'ambassador',
        },
        {
          text: 'videos count',
          value: 'videos_count',
        },
        {
          text: 'videos for editor',
          value: 'videos_for_editor_count',
        },
        {
          text: 'videos in archive',
          value: 'videos_in_archive_count',
        },
        {
          text: 'videos are already in CMS',
          value: 'poi.commonvideodata_count',
          sortable: false,
        },
        {
          text: 'images count',
          value: 'images_count',
          sortable: false,
        },
        {
          text: 'payment',
          value: 'payment_status',
          filter: { type: 'select', items: this.paymentsStatuses },
        },
        {
          text: 'payment milestone',
          value: 'payment_milestone',
          edit: { type: 'number' },
        },
        {
          text: '',
          value: 'deleteItem',
          sortable: false,
          width: '80px',
        },
      ];
    },
    ambHeaders() {
      return [
        {
          text: 'id',
          value: 'id',
          width: '120px',
        },
        {
          text: 'login',
          value: 'login',
        },
        {
          text: 'first_name',
          value: 'first_name',
          edit: { type: 'text', emptyPlaceholder: true },
        },
        {
          text: 'last_name',
          value: 'last_name',
          edit: { type: 'text', emptyPlaceholder: true },
        },
        {
          text: 'nickname',
          value: 'nickname',
          edit: { type: 'text', emptyPlaceholder: true },
        },
        {
          text: 'display_rule',
          value: 'display_rule',
          filter: {
            type: 'select',
            items: [
              // eslint-disable-next-line max-len
              { id: this.$constants.AMB_DISPLAY_RULE.ALIAS, name: this.$constants.AMB_DISPLAY_RULE_LABEL[this.$constants.AMB_DISPLAY_RULE.ALIAS] },
              // eslint-disable-next-line max-len
              { id: this.$constants.AMB_DISPLAY_RULE.INITIALS, name: this.$constants.AMB_DISPLAY_RULE_LABEL[this.$constants.AMB_DISPLAY_RULE.INITIALS] },
              // eslint-disable-next-line max-len
              { id: this.$constants.AMB_DISPLAY_RULE.NICKNAME, name: this.$constants.AMB_DISPLAY_RULE_LABEL[this.$constants.AMB_DISPLAY_RULE.NICKNAME] },
            ],
          },
          edit: {
            type: 'select',
            items: [
              // eslint-disable-next-line max-len
              { id: this.$constants.AMB_DISPLAY_RULE.ALIAS, name: this.$constants.AMB_DISPLAY_RULE_LABEL[this.$constants.AMB_DISPLAY_RULE.ALIAS] },
              // eslint-disable-next-line max-len
              { id: this.$constants.AMB_DISPLAY_RULE.INITIALS, name: this.$constants.AMB_DISPLAY_RULE_LABEL[this.$constants.AMB_DISPLAY_RULE.INITIALS] },
              // eslint-disable-next-line max-len
              { id: this.$constants.AMB_DISPLAY_RULE.NICKNAME, name: this.$constants.AMB_DISPLAY_RULE_LABEL[this.$constants.AMB_DISPLAY_RULE.NICKNAME] },
            ],
            itemText: 'name',
            itemValue: 'id',
            emptyPlaceholder: true,
          },
        },
        {
          text: 'postal_code',
          value: 'postal_code',
          edit: { type: 'text' },
        },
        {
          text: 'city',
          value: 'city',
          edit: { type: 'text', emptyPlaceholder: true },
        },
        {
          text: 'avatar',
          value: 'avatar',
          filter: { type: 'select', items: [{ id: 0, name: 'Empty' }, { id: 1, name: 'Not empty' }] },
        },
        {
          text: 'approved',
          value: 'approved',
          filter: { type: 'select', items: [{ id: 0, name: 'Not approved' }, { id: 1, name: 'Approved' }] },
        },
        {
          text: 'email',
          value: 'email',
          edit: { type: 'text', emptyPlaceholder: true },
        },
        {
          text: 'agreement_status',
          value: 'agreement_status',
          filter: { type: 'select', items: this.agreementStatuses },
        },
        {
          text: 'confirm_terms',
          value: 'confirm_terms',
        },
        {
          text: 'confirm_terms_version',
          value: 'confirm_terms_version',
        },
        {
          text: '',
          value: 'deleteItem',
          sortable: false,
          width: '80px',
        },
      ];
    },
    newAvatar() {
      return (this.imageDialog.newAvatarFile !== null && this.imageDialog.valid) ? URL.createObjectURL(this.imageDialog.newAvatarFile) : '';
    },
  },

  deactivated() {
    this.$destroy();
  },
};
</script>

<style scoped>
.amb-img {
  width: 40px;
  height: 40px;
  border: 2px solid #1976d2;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.amb-img img {
  left: 50%;
  min-height: 100%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.amb-img:before {
  border: 2px solid #fff;
  border-radius: 50%;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}
.amb-placeholder {
  align-items: center;
  background: #f2f4f8;
  color: #ccc;
  display: flex;
  flex-direction: column;
  font-weight: 700;
  height: 100%;
  justify-content: center;
  padding: 2px;
  text-transform: uppercase;
}
.empty-avatar-text {
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-dialog-buttons {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
